import {Aseprite} from '@theatrejs/plugin-aseprite';import data from './exit.json';import texture from './exit.png';export default new Aseprite(texture, data);